import Vue from 'vue'
import Router from 'vue-router'

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    breadcrumb: false            if false, the item will hidden in breadcrumb(default is true)
  }
**/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  { path: '/404', name: '404', component: () => import('@/views/404'), hidden: true },
  { path: '/application', component: () => import('@/views/application'), hidden: true },
  { path: '/applicationSuccess', name: 'ApplicationSuccess', component: () => import('@/views/applicationSuccess'), hidden: true },

  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'Home',
    // hidden: true,
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: 'Home', icon: 'home' }
      }
    ]
  },

  {
    path: '/orders',
    component: Layout,
    children: [
      {
        path: 'order-list',
        name: 'OrderList',
        component: () => import('@/views/orders/orderList'),
        meta: { title: 'Orders', icon: 'orders' }
      }
    ]
  },
  {
    path: '/orders/order-details',
    component: Layout,
    hidden: true,
    children: [
      {
        path: ':orderId',
        name: 'OrderDetails',
        component: () => import('@/views/orders/orderDetails'),
        meta: {
          title: 'OrderDetails'
        }
      }
    ]
  },

  {
    path: '/member',
    component: Layout,
    redirect: 'noredirect',
    meta: {
      title: 'Members',
      icon: 'member'
    },
    children: [
      {
        path: 'member-list',
        name: 'MemberList',
        component: () => import('@/views/member/memberList'),
        meta: { title: 'MembersList' }
      },
      {
        path: 'discount-list',
        name: 'DiscountList',
        component: () => import('@/views/member/discountList'),
        meta: { title: 'DiscountList' }
      },
      {
        path: 'level-list',
        name: 'LevelList',
        component: () => import('@/views/member/levelList'),
        meta: { title: 'LevelList' }
      }
    ]
  },

  {
    path: '/goods',
    component: Layout,
    children: [
      {
        path: 'goods-list',
        name: 'GoodsList',
        component: () => import('@/views/goods/goodsList'),
        meta: { title: 'Goods', icon: 'goods' }
      }
    ]
  },

  {
    path: '/wallet',
    component: Layout,
    children: [
      {
        path: 'wallet-list',
        name: 'WalletList',
        component: () => import('@/views/wallet/walletList'),
        meta: { title: 'Wallet', icon: 'money' }
      }
    ]
  },

  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})
